/**
 * Created by mark on 25/01/2018.
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import CurriculumService from '../services/curriculums-services.js';
import ContentService from '../services/content-service.js';
import ModuleService from '../services/screens-service.js';
import ModulesStore from '../store/screen-store.js';
import ContentStore from '../store/content-store.js';
import VocabObject from './content-target-vocab.js';
import Translation from '../store/internationalization-store.js';
import { Button , Panel , Breadcrumb , Col  , Row  } from 'react-bootstrap';

export default class HomeworkContentSelection extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.onSelected = this.props.onSelected || function(){};
        this.totalWords = 0;
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.totalWords = this.props.totalItems;
        this.setState({updated:true});
    }

    
    fetchCatalog(a , b , c){
        this.props.fetchCatalog(a , b , c)
    }
    

    fetchModules(a , b , c){
        this.props.fetchModules(a , b , c)
    }

    addSection(){
        var add = true;

        var sections = this.props.sections || [];

        for(var index = 0 ; index < sections.length; index++)
        {
            if(sections[index] == this.props.catalogUID)
            {
                add = false;
                sections.splice(index , index + 1)
            }
        }

        if(add)
        {
            sections.push(this.props.catalogUID)
        }

        this.onSelected(sections);
    }

    isAdded(){
        return this.props.sections.indexOf(this.props.catalogUID) > -1;
    }

    render(){

        if(!this.props.modules) return null;

        let breadcrumbs = this.props.history.map(function(crumb , index){

            let onClick = (index != this.props.history.length - 1) ? this.fetchModules.bind(this , crumb.screenID , false , crumb.name) : function(){}
            return <Breadcrumb.Item active={!(index != this.props.history.length - 1)} onClick={onClick} >{crumb.name}</Breadcrumb.Item>

        }.bind(this));

        let modules = this.props.modules.map(function(module){

            let onClick = !module.isLast  ? this.fetchModules.bind(this , module.screenID , false , module.title || Translation.getModuleNoIndexTranslation(module.translationID)) : this.fetchCatalog.bind(this , module.catalog_uid , module.title || Translation.getModuleNoIndexTranslation(module.translationID) , module.screenID );
            let icon    = !module.isLast  ?  <i className=" zmdi-hc-2x zmdi zmdi-chevron-right"></i> : <i className="zmdi-hc-2x zmdi zmdi-format-list-bulleted"></i>;

            if(this.props.sections.indexOf(module.catalog_uid) > -1)
            {
                icon = <i className=" zmdi-hc-2x zmdi zmdi-check"></i>
            }

            return <Col md={3}>
                <div className="b-1 m-b-10"  onClick={onClick}>

                    <div  style={{width:'100%' , textAlign:'left'}} className="p-5 vert-center">
                        <p  style={{margin:0}}> {module.title || Translation.getModuleNoIndexTranslation(module.translationID)}</p>
                    </div>
                    <div  style={{width:50}} className="p-10 vert-center">
                        {icon}
                    </div>
                </div>
            </Col>

        }.bind(this));

        var VocabObjects = [];

        for(var idx = 0 ; idx < this.props.catalog.items.length; idx++)
        {
            let vocabObject = this.props.catalog.items[idx];
            VocabObjects.push(<Col md={3}><VocabObject vocab={vocabObject}/></Col>);
        }

        var msg = !this.isAdded() ? <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Add Section' }/> : <FormattedMessage id={ 'ui-000' } defaultMessage={ 'Remove Section' }/>

        return   <div>
            <Breadcrumb className="b-1">
                {breadcrumbs}
                <span className="pull-right">&nbsp;&nbsp;<FormattedMessage id={ 'ui-000' } defaultMessage={ 'Total Sections' }/> : {this.props.sections.length}</span>
                <span className="pull-right">&nbsp;&nbsp;<FormattedMessage id={ 'ui-000' } defaultMessage={ 'Total Items' }/> : {this.totalWords}</span>

            </Breadcrumb>
            <Panel collapsible expanded={VocabObjects.length == 0}>
                <Row>
                    {modules}
                </Row>
            </Panel>
            <Panel collapsible expanded={VocabObjects.length > 0}>
                <Row>
                    <Col md={12}>
                        <Button block onClick={this.addSection.bind(this)} bsStyle={!this.isAdded() ? 'primary' : 'danger'}>
                            <b>{msg}</b>
                        </Button>
                    </Col>
                </Row>
                <Row className="p-t-10">
                    {VocabObjects}
                </Row>
            </Panel>
        </div>


    }


}


// WEBPACK FOOTER //
// ./src/components/Homeowork-content-selection.js